import PropTypes from "prop-types";
import Grid from "@mui/material/Unstable_Grid2";
import { Typography, Link } from "@mui/material";
import dayjs from "dayjs";
import { MAPPING_KEYS_DATE_FORMAT } from "../../../constants";

import { initLocalization } from "../../../utils/helpers";
import { poolMetadataStrings } from "./locale";
import "./style.scss";

export const PoolMetadata = ({ creativeDetails, isReview }) => {
  initLocalization(poolMetadataStrings);

  return (
    <Grid>
      <Typography paddingLeft="0.5rem" fontWeight="bold">
        {poolMetadataStrings.metadataTitle}:
      </Typography>
      <Grid className="pool-metadata" container flexDirection="column">
        {isReview && (
          <>
            <Grid container width="100%" className="pool-metadata__table-row">
              <Typography className="pool-metadata__table-title">
                {poolMetadataStrings.id}
              </Typography>
              <Typography className="pool-metadata__table-content">
                {creativeDetails.providerCreativeId}
              </Typography>
            </Grid>
            <Grid container width="100%" className="pool-metadata__table-row">
              <Typography className="pool-metadata__table-title">
                {poolMetadataStrings.hash}
              </Typography>
              <Typography className="pool-metadata__table-content">
                {creativeDetails.creativeHashCode}
              </Typography>
            </Grid>
          </>
        )}
        {!isReview && (
          <>
            <Grid container width="100%" className="pool-metadata__table-row">
              <Typography className="pool-metadata__table-title">
                {poolMetadataStrings.providerId}
              </Typography>
              <Typography className="pool-metadata__table-content">
                {creativeDetails.creativeId}
              </Typography>
            </Grid>
            <Grid container width="100%" className="pool-metadata__table-row">
              <Typography className="pool-metadata__table-title">
                {poolMetadataStrings.id}
              </Typography>
              <Typography className="pool-metadata__table-content">
                {creativeDetails.id}
              </Typography>
            </Grid>
            <Grid container width="100%" className="pool-metadata__table-row">
              <Typography className="pool-metadata__table-title">
                {poolMetadataStrings.type}
              </Typography>
              <Typography className="pool-metadata__table-content">
                {creativeDetails.mediaTypeName}
              </Typography>
            </Grid>
            <Grid container width="100%" className="pool-metadata__table-row">
              <Typography className="pool-metadata__table-title">
                {poolMetadataStrings.date}
              </Typography>
              <Typography className="pool-metadata__table-content">
                {dayjs(creativeDetails.date).format(MAPPING_KEYS_DATE_FORMAT)}
              </Typography>
            </Grid>
            <Grid container width="100%" className="pool-metadata__table-row">
              <Typography className="pool-metadata__table-title">
                {poolMetadataStrings.campaign}
              </Typography>
              <Typography className="pool-metadata__table-content">
                {creativeDetails.campaignTitle}
              </Typography>
            </Grid>
            <Grid container width="100%" className="pool-metadata__table-row">
              <Typography className="pool-metadata__table-title">
                {poolMetadataStrings.advertiser}
              </Typography>
              <Typography className="pool-metadata__table-content">
                {creativeDetails.advertiserName}
              </Typography>
            </Grid>
            <Grid container width="100%" className="pool-metadata__table-row">
              <Typography className="pool-metadata__table-title">
                {poolMetadataStrings.link}
              </Typography>
              <Typography className="pool-metadata__table-content">
                <Link href={creativeDetails.creativeLink} target="_blank">
                  {poolMetadataStrings.link}
                </Link>
              </Typography>
            </Grid>
            <Grid container width="100%" className="pool-metadata__table-row">
              <Typography className="pool-metadata__table-title">
                {poolMetadataStrings.title}
              </Typography>
              <Typography className="pool-metadata__table-content">
                {creativeDetails.title}
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  );
};

PoolMetadata.propTypes = {
  creativeDetails: PropTypes.object.isRequired,
  isReview: PropTypes.bool,
};
